
import { useState } from 'react';
import { useFindOneEmailQuery } from '../../../../features/mailsApi';
import { colors } from '../../../ui/colors';
import { MailIcon } from '../../../ui/icons/mail';
import Pills from '../../../ui/molecules/pills';
import { Spinner } from '../../../ui/molecules/spinner';
import { NotFound } from '../../../ui/organisms/notFound';
import { TargetListDTO } from '../../targetList/dto';
import { EmailsMessagesDTO, FindAllCustomMailsResponseDTO } from './dto';

interface Props {
  targetList: TargetListDTO
  emailsHistory: EmailsMessagesDTO[]
  templates: FindAllCustomMailsResponseDTO
}

export function SentMailsList({ emailsHistory, templates }: Props) {
  const [emailId, setEmailId] = useState<string | undefined>(undefined)
  const { data: emailData, isLoading: isLoadingEmail } = useFindOneEmailQuery(emailId!, { skip: !emailId })

  if (!emailsHistory || emailsHistory.length === 0) {
    return <NotFound />
  }
  return (
    <div className="p-6 border-t border-t-neutral-100 w-full flex flex-col items-start gap-4">
      {
        emailsHistory.map((email, index) => {
          if (email)
            return (
              <div key={email.msg_id} onClick={() => setEmailId(email.msg_id)} className="rounded-lg cursor-pointer border w-full border-neutral-100 bg-white hover:bg-neutral-50 shadow-xs hover:shadow-none p-3 flex flex-col items-center justify-center gap-3">
                <div className="flex items-start justify-between gap-1 w-full">
                  <div className="flex flex-col items-start w-full gap-2">
                    <span className="text-text-sm w-full font-bold text-left text-neutral-800">
                      {email.from_email}
                    </span>
                    {(isLoadingEmail && email.msg_id === emailId) && <Spinner size={10} />}
                    {emailData && emailData.msg_id === email.msg_id &&
                      <div className=' flex flex-col gap-1'>
                        <span className="text-text-xs w-full font-bold text-left text-neutral-600">A: {email.to_email}</span>
                        <div className=' flex gap-2.5 items-center '>
                          <Pills
                            startIcon={<MailIcon color={colors.brandPrimary[800]} size={14} />} size={'xs'}
                            label={(templates && templates.data.find(item => item.subject === emailData.subject)) ?
                              templates.data.find(item =>
                                item.subject === emailData.subject)!.templateName : 'Template non trovato'}
                            outline={false} emphasis={false} color={'blue'}
                          />
                          <span className=' text-text-xs text-neutral-700'>
                            {email.last_event_time.slice(0, 10) + " " + email.last_event_time.slice(11, 19)}
                          </span>
                          <span className=' text-text-xs text-neutral-700'>
                            {email.status === 'delivered' && email.opens_count === 0 ? '✔' : '✔✔'}
                          </span>
                        </div>
                      </div>
                    }
                    <span className="text-text-sm font-medium text-neutral-700">
                      {email.subject}
                    </span>
                  </div>
                </div>
              </div>
            )
        })
      }
    </div>
  )
}
